
@if (loadedImage) {
  <div >
    <div
      #canvas
      class="canvas fs-block fs-exclude"
  [ngClass]="{
    'allow-edit': allowEdit,
    'no-edit': !allowEdit,
    'active-document': showActiveBorder
  }"
      [ngStyle]="canvasStyle()"
      (mousedown)="startAction($event, null, 'addNew')"
      (mouseup)="stopAction($event)"
      (mousemove)="trackMovement($event)"
      >
      @for (box of boxes; track box; let idx = $index) {
        <div
          class="box"
          [ngStyle]="boxStyle(box)"
          (mousedown)="startAction($event, box, 'move')"
          (mouseup)="checkForClick($event, idx)"
    [ngClass]="{
      'active': box.active,
      'selected': box.selected,
      'hide-corners': !shouldShowCorners(box),
      'drawing': box.isDrawing
    }"
          >
          @if (box.label) {
            <span class="box-label">{{ box.label }}</span>
          }
          @if (allowEdit) {
            <button class="btn btn-danger remove-box"
              (click)="onDeleteBox($event, idx)"
              (mousedown)="$event.stopPropagation()"
            >Delete</button>
          }
          <span class="corner-target corner-nw"
            (mousedown)="startAction($event, box, 'resize', 'se')"
            >
            <i class="fas fa-arrow-down"></i>
          </span>
          <span class="corner-target corner-ne"
            (mousedown)="startAction($event, box, 'resize', 'sw')"
            >
            <i class="fas fa-arrow-down"></i>
          </span>
          <span class="corner-target corner-se"
            (mousedown)="startAction($event, box, 'resize', 'nw')"
            >
            <i class="fas fa-arrow-down"></i>
          </span>
          <span class="corner-target corner-sw"
            (mousedown)="startAction($event, box, 'resize', 'ne')"
            >
            <i class="fas fa-arrow-down"></i>
          </span>
          <span class="resize resize-top"
            (mousedown)="startAction($event, box, 'resize', 's')"
          ></span>
          <span class="resize resize-e"
            (mousedown)="startAction($event, box, 'resize', 'w')"
          ></span>
          <span class="resize resize-s"
            (mousedown)="startAction($event, box, 'resize', 'n')"
          ></span>
          <span class="resize resize-w"
            (mousedown)="startAction($event, box, 'resize', 'e')"
          ></span>
        </div>
      }
    </div>
  </div>
} @else {
  <div class="image-loading-placeholder" [style.width.px]="inputImageWidth"
    [style.height.px]="inputImageWidth*defaultHeightWidthRatio">
    @if (!imageFailedToLoad) {
      <div class="loader"></div>
    } @else {
      <i class="fa fa-circle-exclamation"></i>
    }
  </div>
}
